





















































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class';
import event from '@/store/modules/event';
import Highcharts from "highcharts";
import {locales} from "@/helpers/locales";
import TooltipSimple from "@/components/UI/TooltipSimple.vue";
import IQuestion from "@/components/icons/IQuestion.vue";

const statistics = namespace('newstatistics')
const show = namespace('event')

@Component({
  name: 'DataScanStandmansFromTime',
  components: {TooltipSimple, IQuestion}
})
export default class DataScanStandmansFromTime extends Vue {

  @Prop({type: Array, default: []}) items!: any
  @Prop({type: String, default: ''}) title!: any
  @Prop({type: String, default: ''}) titletable!: any
  @Prop({type: Boolean, default: true}) protected loading!: boolean

  @Watch('filteredItems', {immediate: true, deep: true})
  onChartLoad(_: boolean) {
    setTimeout(() => this.updateSeries(), 0)
  }

  @Watch('$i18n.locale', {immediate: true})
  onLocaleChanged(_: any) {
    this.updateLocale()
  }

  get currentHeight() {
    return this.filteredItems.length > 6 ? String(100 + (this.filteredItems.length * 40)) : '400'
  }

  updateLocale() {
    this.chartOptions.chart.height = this.currentHeight
    Highcharts.setOptions({
      lang: {
        shortMonths: locales[this.$i18n.locale]
      }
    })
    this.seriesConfig.customContacts.name = this.$t('newstatistics.visitor_badges_scanned.custom_contacts_collected')
    this.seriesConfig.businessCards.name = this.$t('newstatistics.v4.general.contacts_collected.businessCards')
    this.seriesConfig.badges.name = this.$t('newstatistics.visitor_badges_scanned.badges_collected')

    this.chartOptions.series[0] = { ...this.seriesConfig.customContacts, data: this.customContacts, ti: this.$t('newstatistics.total.contacts') }
    this.chartOptions.series[1] = { ...this.seriesConfig.businessCards, data: this.businessCards, ti: this.$t('newstatistics.total.contacts') }
    this.chartOptions.series[2] = { ...this.seriesConfig.badges, data: this.badges, ti: this.$t('newstatistics.total.contacts') }
    this.chartOptions.xAxis.categories = this.categories
    const chart: any = this.$refs.charts
    if (!chart) return
    chart.chart.update({ ...this.chartOptions })
  }

  itemCharts: [] = this.items
  allCheck: boolean = false
  seriesConfig = {
    badges: {
      color: '#5871d0',
      name: this.$t('newstatistics.visitor_badges_scanned.badges_collected'),
       ti: this.$t('newstatistics.total.contacts')

    },
    businessCards: {
      color: '#69A47B',
      name: this.$t('newstatistics.visitor_badges_scanned.business_cards_collected'),
       ti: this.$t('newstatistics.total.contacts')

    },
    customContacts: {
      color: '#CC7D7D',
      name: this.$t('newstatistics.visitor_badges_scanned.custom_contacts_collected'),
       ti: this.$t('newstatistics.total.contacts')


    }
  }

  @Watch('allCheck')
  get(NewVal: any) {
    if (NewVal) {
      this.itemCharts.map((ele: any) => {
        ele.show = true
      })
    } else {
      this.itemCharts.map((ele: any) => {
        ele.show = false
      })
    }
  }

  updateSeries() {
    if (!this.itemCharts.length) return
    const chart: any = this.$refs.charts
    if (!chart) return
    chart.chart.update({
      series: [
        {
          ...this.seriesConfig.customContacts,
          data: this.customContacts
        }, {
          ...this.seriesConfig.businessCards,
          data: this.businessCards
        },{
          ...this.seriesConfig.badges,
          data: this.badges,
        },
      ],
      xAxis: {
        categories: this.categories
      },
    })
    chart.chart.setSize(null, this.currentHeight)
  }

  get hasStandmansWithData() {
    return this.filteredItems.some((standman: any) => standman.total)
  }

  get filteredItems() {
    return this.itemCharts.filter((ele: any) => ele.show === true)
  }

  get badges() {
    if (!this.filteredItems.length) return []
    return this.filteredItems.map((item: any) => {
      return item.badges
    })
  }

  get businessCards() {
    if (!this.filteredItems.length) return []
    return this.filteredItems.map((item: any) => {
      return item.businessCards
    })
  }

  get customContacts() {
    if (!this.filteredItems.length) return []
    return this.filteredItems.map((item: any) => {
      return item.customContacts
    })
  }

  get categories() {
    if (!this.filteredItems.length) return []
    return this.filteredItems.map((item: any) => {
      return item.name
    })
  }

  chartOptions = {
    chart: {
      type: 'bar',
      style: {"fontSize": "12px"},
      height: this.currentHeight,
      backgroundColor: '#F3F2F7',
      borderRadius: 10,
      marginRight: '30',
      marginTop: '50',
      marginBottom: '65',
    },
       title: {
      text: ''
    },
    subtitle: {
      text: '',
    },
    tooltip: {
      backgroundColor: null,
      borderWidth: 0,
      shadow: false,
      useHTML: true,
      style: {
        padding: 0
      },
      formatter: function (): any {
        const context: any = this
        return '<div class="statistics-v4-tooltip">'
          + '<span class="statistics-v4-tooltip-title">'
          + context.x +
          '</span><br><span class="statistics-v4-tooltip-subtitle">'
          + context.point.series.name + ': ' + context.y
          + '<br><br>'+context.series.userOptions.ti+': ' + context.total+'</span>'+
          +'</div>'
      },
    },
    credits: {
      enabled: false
    },
    xAxis: {
      categories: this.categories,
      gridLineDashStyle: 'dot',
      gridLineWidth: 2,
    },
    yAxis: {
      min: 0,
      allowDecimals: false,
      title: null,
      gridLineDashStyle: 'dot',
      gridLineWidth: 2,
      tickPixelInterval: 200,
    },
    legend: {
      enabled: true,
      layout: 'horizontal',
      verticalAlign: 'bottom',
      floating: false,
      itemStyle: {
        marginRight:'130px',
        fontSize: '15',
        fontWeight: '700',
        color: ' #0A0A0A',
        textOverflow: 'ellipsis'
      }
    },
    plotOptions: {
      bar: {
        legend: {
          enabled: true
        },
        dataLabels: {
          enabled: false,
          inside: false
        }
      },
      series: {
        stacking: 'normal'
      }
    },
    series: [
       {
        ...this.seriesConfig.badges,
        data: this.badges,
          ti: this.$t('newstatistics.total.contacts'),
      },
      {
        ...this.seriesConfig.businessCards,
        data: this.businessCards,
         ti: this.$t('newstatistics.total.contacts'),
      },
      {
        ...this.seriesConfig.customContacts,
        data: this.customContacts,
         ti: this.$t('newstatistics.total.contacts'),
      },
    ]
  }

}
